module.exports = __webpack_public_path__ + "img/p5.1081062c.png";